import {combineReducers} from 'redux'
import appReducer from './reducers/app'
import userReducer from './reducers/user'
import memberReducer from './reducers/member'
import cookiesReducer from './reducers/cookies'
import {connectRouter} from 'connected-react-router'

const rootReducer = (history) =>
  combineReducers({
    app: appReducer,
    user: userReducer,
    member: memberReducer,
    cookies: cookiesReducer,
    router: connectRouter(history),
  })

export default rootReducer
